const { ofetch } = require("ofetch");

$(function() {
    //var JCGlobalObject = (JCGlobalObject) ? JCGlobalObject : false;
    if (!window.hasOwnProperty('JCGlobalObject')) { return false; }

    var LoadMore1AParams = {
        //scroll load options
        order: JCGlobalObject[JCGlobalObject.namespace].params.order,
        orderby: JCGlobalObject[JCGlobalObject.namespace].params.orderby,
        postType: JCGlobalObject[JCGlobalObject.namespace].params.post_type,
        postsPerPage: JCGlobalObject[JCGlobalObject.namespace].params.posts_per_page,
        taxonomy: (JCGlobalObject[JCGlobalObject.namespace].params.hasOwnProperty('tax_query')) ? JCGlobalObject[JCGlobalObject.namespace].params.tax_query[0]['taxonomy'] : undefined,
        field: (JCGlobalObject[JCGlobalObject.namespace].params.hasOwnProperty('tax_query')) ? JCGlobalObject[JCGlobalObject.namespace].params.tax_query[0]['field'] : undefined,
        terms: (JCGlobalObject[JCGlobalObject.namespace].params.hasOwnProperty('tax_query')) ? JCGlobalObject[JCGlobalObject.namespace].params.tax_query[0]['terms'] : undefined,
        operator: (JCGlobalObject[JCGlobalObject.namespace].params.hasOwnProperty('tax_query')) ? JCGlobalObject[JCGlobalObject.namespace].params.tax_query[0]['operator'] : undefined,
        maxNumPages: JCGlobalObject[JCGlobalObject.namespace].params.max_num_pages,
        metaKey: JCGlobalObject[JCGlobalObject.namespace].params.meta_key,
        metaValue: JCGlobalObject[JCGlobalObject.namespace].params.meta_value,
        namespace: JCGlobalObject.namespace,
        prefix: JCGlobalObject.prefix,
        offset: 0,
        currentPage: 1,
        resultsLoading: false,
    };

    const fetchData = async function(index) {
        if (LoadMore1AParams.resultsLoading) { return; }

        var $tiggerBtn = $(index);
        var $root = $(index).parents('.component-load-more-1A__root');
        var $dataset = $root.find('.component-load-more-1A__dataset');
        var action = $dataset.data('load-more-1a-fetch');

        //ui controls
        $tiggerBtn.addClass('active');
        LoadMore1AParams.resultsLoading = true;

        //Update paging
        LoadMore1AParams.offset = (LoadMore1AParams.currentPage * LoadMore1AParams.postsPerPage);

        var query = {
            meta_key:LoadMore1AParams.metaKey,
            meta_value:LoadMore1AParams.metaValue,
            order:LoadMore1AParams.order,
            orderby:LoadMore1AParams.orderby,
            post_type:LoadMore1AParams.postType,
            posts_per_page:LoadMore1AParams.postsPerPage,
            //taxonomy:LoadMore1AParams.taxonomy,
            //terms:LoadMore1AParams.terms,
            //operator:LoadMore1AParams.operator,
            offset:LoadMore1AParams.offset,
            namespace:LoadMore1AParams.namespace
        };
        const data = await ofetch(LoadMore1AParams.prefix + action, { method:"GET", query:query });

        //update html
        $(data.html).appendTo($dataset);
        $tiggerBtn.removeClass('active');

        //update stats
        LoadMore1AParams.maxNumPages = data.stats.max_num_pages;
        LoadMore1AParams.resultsLoading = false;
        LoadMore1AParams.currentPage++;

        if (LoadMore1AParams.currentPage >= LoadMore1AParams.maxNumPages) {
            $tiggerBtn.addClass('inactive');
        }
    }

    $('.component-load-more-1A__load').on('click', function() {
        fetchData(this);
    })
});